// extracted by mini-css-extract-plugin
module.exports = {"bookingsTextStyle":"TotalBookingsField_bookingsTextStyle__2ouqg"};